<template>
    <div class="home">
        <sidebar class="sidebar"
             v-click-outside="closeSidebar"
             :class="sidebarClass">
            sidebar
        </sidebar>
        <div class="content">
            <div class="header">
                <div class="icon" @click.stop="openSidebar">
                    <img src="@/assets/img/menu.svg">
                    <div v-show="unreadCount"  class="number">{{ unreadCount }}</div>
                </div>
                <div class="title">
                    跑跑腿
                </div>
            </div>
            <div class="ad">
                <carousel :autoplay="true"
                          :autoplayTimeout="3000"
                          :perPage="1"
                          :centerMode="true"
                          :loop="true"
                          :paginationPosition="'bottom-overlay'"
                          paginationActiveColor="#FFFFFF"
                          paginationColor="rgba(255,255,255,0.35)">
                    <slide class="slide"
                           v-for="ad in ads"
                           :key="ad.id">
                        <img :src="ad.photo.url" :alt="ad.title" @click="clickAD(ad)">
                    </slide>
                </carousel>
            </div>
            <v-menu/>
        </div>
        <div class="shadow" :class="{active: isOpen}" @click.prevent></div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Carousel, Slide } from 'vue-carousel';
import Sidebar from './components/Sidebar';
import Menu from './components/Memu';

export default {
    name: 'Home',
    components: {
        'sidebar': Sidebar,
        'carousel': Carousel,
        'slide': Slide,
        'v-menu': Menu,
    },
    data() {
        return {
            isOpen: false,
        }
    },
    computed: {
        sidebarClass() {
            return {
                collapsed: ! this.isOpen,
            }
        },
        ...mapGetters(['name', 'ads', 'unreadCount', 'isLogin'])
    },
    methods: {
        openSidebar() {
            this.isOpen = true;
        },
        closeSidebar() {
            this.isOpen = false;
        },
        clickAD(ad) {
            switch (ad.type) {
                case 'url':
                    window.open(ad.url);
                    break;
                case 'category':
                    this.$router.push({
                        name: 'ShopList',
                        query: {
                            title: ad.title,
                            'ADIds': Array.from(ad.categories.map(c => c.id).values()),
                        }
                    });
                    break;
                case 'shop':
                    this.$router.push({
                        name: 'AdShops',
                        params: {
                            id: ad.id,
                        }
                    })
                    break;
                case 'buy':
                    this.$router.push({ name: 'buy' });
                    break;
                case 'transport':
                case 'delivery':
                    this.$router.push({ name: 'transport' });
                    break;
                case 'wait':
                    this.$router.push({ name: 'wait' });
                    break;
                case 'elastic':
                    this.$router.push({ name: 'elastic' });
                    break;
                case 'pay':
                    this.$router.push({ name: 'pay' });
                    break;
                case 'wash':
                    this.$router.push({ name: 'wash' });
                    break;
                case 'liquor':
                    this.$router.push({ name: 'liquorShop' });
                    break;
            }
        },
    },
}
</script>

<style scoped>
    .sidebar, .content {
      height: 100%;
      overflow:auto;
    }

    .sidebar {
      position: fixed;
      left: 0;
      top: 0;
      z-index: 10;
      background:white;
      width: 260px;
      box-shadow: 0 2px 4px 0 rgba(51,153,51,0.5);
      transition: width .35s;
    }

    .sidebar.collapsed {
      width: 0;
    }

    .shadow {
        height: 100%;
        width: 0;
        position: fixed;
        left: 0;
        top: 0;
        z-index: 5;
        background-color: rgba(0,0,0,0.4);
    }

    .shadow.active {
        width: 100%;
    }

    .content {
      width: 100%;
    }

    .header {
        display: flex;
        justify-content: space-between;
        padding: 15px 10px;
    }

    .header > .icon {
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
    }

    .header > .icon > img {
        width: 25px;
        height: 25px;
    }

    .header > .title {
        flex: 1;
        margin-right: 25px;
    }

    .header > .icon > .number {
        position: absolute;
        top: 0;
        right: -4px;
        line-height: 16px;
        font-size: 10px;
        width: 16px;
        height: 16px;
        border-radius: 90px;
        border: 1px solid #FFFFFF;
        background-color: #F44336;
        color: #ffffff;
        font-weight: 500;
    }

    .slide > img {
        width: 100%;
        height: auto;
    }
</style>
